export default "__VITE_PUBLIC_ASSET__634ddc92__"